import { bitfToTranslate } from '@bitf/utils/bitf-translate.utils';

export const CONSTANTS = {
  META_TAGS: {
    TITLE: {
      DEFAULT_TITLE: bitfToTranslate('COMMON.META_TAGS.DEFAULT_TITLE'),
      POSTFIX: bitfToTranslate('COMMON.META_TAGS.TITLE_POSTFIX'),
    },
    DESCRIPTION: bitfToTranslate('COMMON.META_TAGS.DESCRIPTION'),
  },
  SUPPORTED_LANGUAGES: [
    { code: 'it', label: 'Italiano' },
    // { code: 'en', label: 'English' },
  ],
  DEFAULT_LANGUAGE: { code: 'it', label: 'Italiano' },
  LOCAL_STORAGE_VERSION: 1,
  DEFAULT_CURRENCY: {
    code: '€',
  },
  URL_ROUTES_TRANSLATION: {
    investments: { it: 'investimenti', en: 'investments' },
    contacts: { it: 'contatti', en: 'contacts' },
    faq: { it: 'faq', en: 'faq' },
    sell: { it: 'vendi-la-tua-auto-o-moto', en: 'sell-your-car-or-bike' },
    priceList: { it: 'listino-prezzi', en: 'price-list' },
    newsletter: { it: 'newsletter', en: 'newsletter' },
  },
};
